import React from "react";
import { Card, Modal, Alert, Spin } from "antd";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

const toDisplayText = (value, fallback = "") => {
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean")
    return String(value);
  if (value && typeof value === "object") {
    if (typeof value.message === "string") return value.message;
    if (typeof value.error === "string") return value.error;
    if (value.error && typeof value.error.message === "string")
      return value.error.message;
  }
  return fallback;
};

export default function Recognize(props) {
  const {
    loading,
    photo,
    visible,
    recognizeFromDataUri,
    recognizeResult,
    onClose
  } = props;

  return (
    <Modal
      title="Test Recognition"
      visible={visible}
      footer={null}
      onCancel={onClose}
    >
      <Spin spinning={loading}>
        {photo ? (
          <img
            style={{ width: "100%", borderRadius: 6, marginBottom: 12 }}
            src={photo}
            alt=""
          />
        ) : null}
        {visible && (
          <Camera
            onTakePhotoAnimationDone={dataUri => {
              recognizeFromDataUri(dataUri);
            }}
            isImageMirror={true}
          />
        )}
        <Card size="small" title="Result">
          {!recognizeResult ? (
            <div style={{ color: "rgba(0,0,0,0.45)" }}>
              Capture a photo to see results.
            </div>
          ) : recognizeResult.error ? (
            <Alert
              type="error"
              message={toDisplayText(recognizeResult.error, "Recognition failed")}
              showIcon
            />
          ) : recognizeResult.match ? (
            <div style={{ lineHeight: 1.8 }}>
              <div>
                <b>Match found</b>
              </div>
              <div>
                <span style={{ color: "rgba(0,0,0,0.45)" }}>Name:</span>{" "}
                {toDisplayText(recognizeResult.match.name, "-")} #{toDisplayText(recognizeResult.match.externalUserId)}
              </div>
              {typeof recognizeResult.confidence === "number" ? (
                <div>
                  <span style={{ color: "rgba(0,0,0,0.45)" }}>Confidence:</span>{" "}
                  {(recognizeResult.confidence * 100).toFixed(1)}%
                </div>
              ) : null}
            </div>
          ) : (
            <div style={{ color: "rgba(0,0,0,0.65)" }}>
              {toDisplayText(recognizeResult.message, "No match")}
            </div>
          )}
        </Card>
      </Spin>
    </Modal>
  );
}

